import { Direction } from '@angular/cdk/bidi';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { MINUTES } from 'src/app/modules/route-planner/constants/multi-language.constants';

@Component({
    selector: 'app-filter-section',
    templateUrl: './filter-section.component.html',
    styleUrls: ['./filter-section.component.scss'],
    standalone: false
})
export class FilterSectionComponent implements OnInit{
  @Input() addDivider: boolean = true;
  @Input() title: string;
  @Input() value: number;
  @Input() showValue: boolean = false;
  @Input() max: number;
  @Output() valueChange = new EventEmitter<number>();

  mintuesText: string
  direction: Direction

  constructor(private readonly languageService: LanguageService){}

  ngOnInit(): void {
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction
      this.mintuesText = MINUTES[language.language]
    })
  }

  onValueInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let numValue = parseInt(input.value, 10);
    if (isNaN(numValue) || numValue < 0) {
      numValue = 0;
    } else if (this.max && numValue > this.max) {
      numValue = this.max;
    }
    input.value = String(numValue);
    this.valueChange.emit(numValue);
  }
}
